import { extendTheme, type ThemeConfig } from "@chakra-ui/react";

const config: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  styles: {
    global: {
      // Removed the pseudo-element animation; now a simple thin white border is applied.
      ".profile-container": {
        position: "relative",
        borderRadius: "full",
        backgroundColor: "white",
        border: "2px solid white", // Thin white border around the profile image
      },
    },
  },
});

export default theme;
